import Store from 'lightningjs-redux';

import {
  getTitle,
  getAdPlaybackState,
  getDisplayedAdBreakType,
  getAdBreakDuration,
  getAdBreakElapsedTime,
  getLBannerState,
  getVideoAds,
  getAdElapsedTime,
  getAdSkipOffset,
  isAdvertisementMode,
} from '../../../logic/player/player.selectors';
import { getPlayerAdsCountFeature } from '../../../logic/features/features.selectors';

const mapControllers = instance => [
  {
    selector: getVideoAds,
    callback: value => {
      instance.advertisement = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getAdBreakDuration,
    callback: value => {
      instance.adBreakDuration = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getAdSkipOffset,
    callback: value => {
      instance.adSkipOffset = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getAdElapsedTime,
    callback: value => {
      instance.adElapsedTime = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getAdBreakElapsedTime,
    callback: value => {
      instance.adBreakElapsedTime = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getPlayerAdsCountFeature,
    callback: value => {
      instance.displayAdsCountdown = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: isAdvertisementMode,
    callback: value => {
      instance.isAdvertisementMode = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getTitle,
    callback: value => {
      instance.contentTitle = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getAdPlaybackState,
    callback: value => {
      instance.playbackState = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getDisplayedAdBreakType,
    callback: value => {
      instance.displayedAdBreakType = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getLBannerState,
    callback: value => {
      instance.shouldDisplayLBanner = value;
    },
  },
];

export default Store.control(mapControllers);
